'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _classnames4 = require('classnames');

var _classnames5 = _interopRequireDefault(_classnames4);

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssetTypesBar = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(AssetTypesBar, _React$Component);

  function AssetTypesBar() {
    (0, _classCallCheck3.default)(this, AssetTypesBar);
    return (0, _possibleConstructorReturn3.default)(this, (AssetTypesBar.__proto__ || (0, _getPrototypeOf2.default)(AssetTypesBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(AssetTypesBar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.types.length !== this.props.types.length || nextProps.type !== this.props.type;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _classnames2,
          _this2 = this;

      var types = this.props.types;
      var isContracted = this.props.isContracted;

      var styles = require('./AssetTypesBar.scss');

      var componentClasses = (0, _classnames5.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.AssetTypes, true), (0, _defineProperty3.default)(_classnames, styles['AssetTypes--contracted'], isContracted), (0, _defineProperty3.default)(_classnames, styles['AssetTypes--sticky'], isContracted && this.props.sticky), _classnames));

      var everythingSelected = this.props.type == 'everything';

      return _react2.default.createElement(
        'ul',
        { className: componentClasses },
        _react2.default.createElement(
          'li',
          { className: styles.AssetType, key: 'everything' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/types/everything', className: (0, _classnames5.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, styles['AssetType__link'], true), (0, _defineProperty3.default)(_classnames2, styles['AssetType__link--active'], everythingSelected), _classnames2)), activeClassName: null },
            _react2.default.createElement(
              'span',
              { className: styles.AssetType__name },
              'Everything'
            )
          )
        ),
        types && types.map(function (type) {
          var _classnames3;

          var selected = _this2.props.type === type.slug;

          var typeImageSrc = (0, _utils.getAssetTypeThumbnail)(type.slug);
          typeImageSrc = "url(" + typeImageSrc + ")";

          var assetTypeLinkClasses = (0, _classnames5.default)((_classnames3 = {}, (0, _defineProperty3.default)(_classnames3, styles['AssetType__link'], true), (0, _defineProperty3.default)(_classnames3, styles['AssetType__link--active'], selected), _classnames3));

          var assetThumb = void 0;

          if (!isContracted) {
            assetThumb = _react2.default.createElement('span', { className: styles.AssetType__thumb, style: { backgroundImage: typeImageSrc } });
          }

          return _react2.default.createElement(
            'li',
            { className: styles.AssetType, key: type.slug },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/types/' + type.slug, className: assetTypeLinkClasses, activeClassName: null },
              _react2.default.createElement(
                'span',
                { className: styles.AssetType__name },
                (0, _utils.pluralize)(type.name)
              ),
              assetThumb
            )
          );
        })
      );
    }
  }]);
  return AssetTypesBar;
}(_react2.default.Component), _class.propTypes = {
  types: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
    name: _react2.default.PropTypes.string.isRequired,
    slug: _react2.default.PropTypes.string.isRequired
  })).isRequired
}, _temp);
exports.default = AssetTypesBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetTypesBar/AssetTypesBar.jsx
// module id = 2486
// module chunks = 0